<template>
  <div>
    <b-card title="Resolved Discrepancy Txn">
      <b-row class="mb-1">
        <!-- search input -->
        <b-col>
          <section>
            <b-button
              v-b-modal.modal-filter-Reconcilation
              variant="outline-primary"
              class="d-flex"
            >
              <feather-icon icon="FilterIcon" />Filter
            </b-button>
          </section>
        </b-col>
        <b-col>
          <b-form-group
            v-if="dataFiltered == true"
            class="d-flex justify-content-center"
          >
            <!-- search input -->
            <div>
              <b-form-input
                v-model="searchTerm"
                type="search"
                placeholder="search"
              />
            </div>
          </b-form-group>
        </b-col>

        <b-col v-if="dataFiltered === true" class="d-flex justify-content-end">
          <xlsx-workbook>
            <xlsx-sheet
              v-for="sheet in sheets"
              :key="sheet.name"
              :collection="sheet.data"
              :sheet-name="sheet.name"
            />
            <xlsx-download>
              <b-button variant="primary" class="d-flex">
                <feather-icon icon="DownloadCloudIcon" /> Export
              </b-button>
            </xlsx-download>
          </xlsx-workbook>
        </b-col>
      </b-row>
      <!-- table -->
      <vue-good-table
        :columns="columns"
        :rows="reconciliations"
        :rtl="direction"
        :search-options="{
          enabled: true,
          skipDiacritics: true,
          externalQuery: searchTerm,
        }"
        :pagination-options="{
          enabled: true,
          perPage: pageLength,
        }"
      >
        <template slot="pagination-bottom" slot-scope="props">
          <!-- pagination -->

          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap"> Showing 1 to </span>
              <b-form-select
                v-model="pageLength"
                :options="['5', '10', '15', '30', '50']"
                class="mx-1"
                @input="
                  (value) => props.perPageChanged({ currentPerPage: value })
                "
              />
              <span class="text-nowrap"> of {{ props.total }} entries </span>
            </div>
            <div>
              <b-pagination
                :value="1"
                :total-rows="props.total"
                :per-page="pageLength"
                first-number
                last-number
                align="right"
                prev-class="prev-item"
                next-class="next-item"
                class="mt-1 mb-0"
                @input="(value) => props.pageChanged({ currentPage: value })"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </div>
          </div>
        </template>
      </vue-good-table>

      <b-row>
        <b-col>
          <b-modal
            id="modal-filter-Reconcilation"
            title="Filter Reconcilation"
            ok-title="Search"
            cancel-variant="outline-secondary"
            size="lg"
            @ok="filterResolvedDiscrepancyTxn"
          >
            <b-form>
              <b-row>
                <b-col cols="6">
                  <b-form-group label="Merchants option" label-for="Merchants">
                    <v-select
                      multiple
                      v-model="selected"
                      :options="merchants"
                      label="name"
                    >
                      <template #option="option">
                        <span>{{ option.name }}</span>
                      </template>
                    </v-select>
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group
                    label="Provider option"
                    label-for="provider-option"
                  >
                    <b-form-select
                      id="ProviderID"
                      v-model="providerId"
                      :options="providers"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Custom Order Code">
                    <b-form-input
                      id="filterCustomOrderCode-input"
                      v-model="customOrderCode"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="3">
                  <b-form-group label="From Amount">
                    <b-form-input
                      id="filterFromAmount-input"
                      v-model="fromamount"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="3">
                  <b-form-group label="To Amount">
                    <b-form-input
                      id="filterTOAmount-input"
                      v-model="toamount"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Transaction Reference">
                    <b-form-input
                      id="filterTransactionReference-input"
                      v-model="transactionReference"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="Transaction Date Range"
                    label-for="transaction-date-range"
                  >
                    <flat-pickr
                      v-model="trxnDateRange"
                      class="form-control"
                      :config="{ mode: 'range', maxDate: 'today' }"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group
                    label="Transaction Type"
                    label-for="transaction-type"
                  >
                    <b-form-select
                      v-model="transactionType"
                      :options="transactionTypeOptions"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="New Reference">
                    <b-form-input
                      id="filterNewReference-input"
                      v-model="newReference"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="New Transaction Date Range"
                    label-for="new-transaction-date-range"
                  >
                    <flat-pickr
                      v-model="newtrxnDateRange"
                      class="form-control"
                      :config="{ mode: 'range', maxDate: 'today' }"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form>
          </b-modal>
        </b-col>
      </b-row>

      <!-- loadings -->
      <b-overlay :show="isLoading" no-wrap rounded="sm" />
    </b-card>
  </div>
</template>

<script>
import {
  BTabs,
  BTab,
  BCard,
  BButton,
  BBadge,
  BPagination,
  BOverlay,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormDatepicker,
  BRow,
  BCol,
  BForm,
  BTable,
  BCardText,
  BFormCheckbox,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import axios from "@axios";
import store from "@/store";
import flatPickr from "vue-flatpickr-component";
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
import XlsxSheet from "../../../../node_modules/vue-xlsx/dist/components/XlsxSheet";
import XlsxDownload from "../../../../node_modules/vue-xlsx/dist/components/XlsxDownload";
import XlsxWorkbook from "../../../../node_modules/vue-xlsx/dist/components/XlsxWorkbook";
import vSelect from "vue-select";
export default {
  components: {
    BTabs,
    BTab,
    BRow,
    BCol,
    BCard,
    VueGoodTable,
    BBadge,
    BButton,
    BOverlay,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormDatepicker,
    flatPickr,
    BForm,
    BTable,
    BCardText,
    BCardActions,
    BFormCheckbox,
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload,
    vSelect,
  },
  data() {
    return {
      isLoading: false,
      dataFiltered: false,
      pageLength: 5,
      dir: false,
      trxnDateRange: "",
      newtrxnDateRange: "",
      merchantIds: "",
      merchants: [],
      selected: [],
      customOrderCode: "",
      fromamount: 0,
      toamount: 0,
      transactionReference: "",
      fromtransactionDate: "",
      totransactionDate: "",
      transactionType: 1,
      newReference: "",
      fromnewTransactionDate: "",
      tonewTransactionDate: "",
      providerId: 0,
      transactionTypeOptions: [
        {
          value: 1,
          text: "Payment",
        },
        {
          value: 2,
          text: "Refund",
        },
      ],
      columns: [
        {
          label: "Merchant Name",
          field: "merchantName",
        },
        {
          label: "Provider",
          field: "providerName",
        },
        {
          label: "Custom Order Code",
          field: "customOrderCode",
        },
        {
          label: "Amount",
          field: "amount",
        },
        {
          label: "Currency",
          field: "currency",
        },
        {
          label: "Transaction Reference",
          field: "transactionReference",
        },
        {
          label: "Transaction Date",
          field: "transactionDate",
        },
        {
          label: "Transaction Type",
          field: "transactionType",
        },
        {
          label: "Customer Name",
          field: "customerName",
        },
        {
          label: "Account Number",
          field: "accountNumber",
        },
        {
          label: "New Transaction Reference",
          field: "newReference",
        },
        {
          label: "New Transaction Date",
          field: "newTransactionDate",
        },
        {
          label: "Action Taken By",
          field: "changedBy",
        },
        {
          label: "Action Date",
          field: "actionDate",
        },
        {
          label: "Remark",
          field: "remark",
        },
      ],
      providers: [{ value: 0, text: "--select Provider--" }],
      searchTerm: "",
      reconciliations: [],
      sheets: [{ name: "Bank Statments", data: [] }],
    };
  },
  computed: {
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        1: "light-success",
        0: "light-danger",
        /* eslint-enable key-spacing */
      };

      return (status) => statusColor[status];
    },
  },
  created() {
    this.fetchallProvider();
    this.fetchMerchant();
  },
  methods: {
    fetchallProvider() {
      this.isLoading = true;
      this.$store.dispatch("config/getActionPrivilege", "Reconciliation-View");
      axios
        .get("/Provider/api/V1.0/Provider/GetAll")
        .then((res) => {
          res.providers.map((provider) => {
            this.providers.push({
              value: provider.id,
              text: provider.providerName,
            });
          });
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    fetchMerchant() {
      this.isLoading = true;
      axios
        .get("/Merchant/api/V1.0/Merchants/GetMerchants")
        .then((res) => {
          res.merchants.forEach((m) => {
            this.merchants.push({ id: m.id, name: m.name });
          });
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.isLoading = false;
        });
    },
    filterResolvedDiscrepancyTxn() {
      this.selected.map((m) => {
        this.merchantIds += m.id + ",";
      });
      this.merchantIds = this.merchantIds.slice(0, -1);
      if (this.trxnDateRange !== "") {
        const [trxSttDate, trxEdDate] = this.trxnDateRange.split(" to ");

        if (this.trxnDateRange.includes("to")) {
          this.fromtransactionDate = trxSttDate;
          this.totransactionDate = trxEdDate;
        } else {
          this.fromtransactionDate = this.trxnDateRange;
          this.totransactionDate = this.trxnDateRange;
        }
      }

      if (this.newtrxnDateRange !== "") {
        const [newtrxnSttDate, newtrxnEdDate] =
          this.newtrxnDateRange.split(" to ");
        // this.trxnEndDate = `${trxnEdDate.trim()}`
        // this.trxnStartDate = `${trxnSttDate.trim()}`

        if (this.newtrxnDateRange.includes("to")) {
          this.fromnewTransactionDate = newtrxnSttDate;
          this.tonewTransactionDate = newtrxnEdDate;
        } else {
          this.fromnewTransactionDate = this.newtrxnDateRange;
          this.tonewTransactionDate = this.newtrxnDateRange;
        }
      }
      const url = `/Reconciliation/api/V1.0/Reconciliation/GetResolvedMismatchedTransactions?merchantIds=${this.merchantIds}&customOrderCode${this.customOrderCode}&fromamount=${this.fromamount}&toamount=${this.toamount}&transactionReference=${this.transactionReference}&fromtransactionDate=${this.fromtransactionDate}&totransactionDate=${this.totransactionDate}&transactionType=${this.transactionType}&newReference=${this.newReference}&fromnewTransactionDate=${this.fromnewTransactionDate}&tonewTransactionDate=${this.tonewTransactionDate}&providerId=${this.providerId}`;
      // Api call
      this.isLoading = true;
      axios
        .get(url)
        .then((res) => {
          this.sheets[0].data = [];
          this.dataFiltered = true;
          this.reconciliations = res.resolvedTransactions;
          res.resolvedTransactions.map((m) => {
            this.sheets[0].data.push({
              merchantName: m.merchantName,
              providerName: m.providerName,
              customOrderCode: m.customOrderCode,
              amount: m.amount,
              currency: m.currency,
              transactionReference: m.transactionReference,
              transactionDate: m.transactionDate,
              transactionType: m.transactionType,
              customerName: m.customerName,
              accountNumber: m.accountNumber,
              newReference: m.newReference,
              newTransactionDate: m.newTransactionDate,
              changedBy: m.changedBy,
              actionDate: m.actionDate,
              remark: m.remark,
            });
          });
          this.isLoading = false;
          this.fromtransactionDate = "";
          this.totransactionDate = "";
          this.fromnewTransactionDate = "";
          this.tonewTransactionDate = "";

          this.merchantIds = "";
        })
        .catch((res) => {
          this.isLoading = false;
          this.dataFiltered = false;
          this.reconciliations = [];
          this.sheets[0].data = [];
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              icon: "BellIcon",
              variant: "danger",
              text: `${res.data.message}`,
            },
          });
          // this.$refs.loginForm.setErrors(error)
          this.fromtransactionDate = "";
          this.totransactionDate = "";
          this.fromnewTransactionDate = "";
          this.tonewTransactionDate = "";

          this.merchantIds = "";
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

<style lang="scss">
@import "@core/scss/vue/pages/page-pricing.scss";
</style>
